/**
 * Pure Scentum — product grid "Add to Cart".
 * Uses Shopify's AJAX Cart API (/cart/add.js) so the page never reloads,
 * shows a temporary "Added ✓" label (matching the original design), and
 * dispatches a "ps:cart:updated" event other theme sections (a cart drawer,
 * a header cart count) can listen for.
 */
(function () {
  function setLabel(btn, text, restoreAfter) {
    var original = btn.getAttribute('data-ps-label-default') || btn.textContent.trim();
    btn.setAttribute('data-ps-label-default', original);
    btn.textContent = text;
    if (restoreAfter) {
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, restoreAfter);
    }
  }

  function handleSubmit(e) {
    var form = e.target.closest('[data-ps-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-ps-add-btn]');
    var variantId = form.querySelector('[name="id"]').value;
    if (!variantId) return;

    if (btn) { btn.disabled = true; setLabel(btn, 'Adding…'); }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          if (btn) setLabel(btn, 'Try again', 1800);
          return;
        }
        if (btn) setLabel(btn, 'Added ✓', 1600);
        document.dispatchEvent(new CustomEvent('ps:cart:updated', { detail: data }));
      })
      .catch(function () {
        if (btn) setLabel(btn, 'Try again', 1800);
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
